import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonLevel, ButtonStyle } from '@challenger6/vm-pattern-library/button';

@Component({
  selector: 'vm-yes-no-cta',
  templateUrl: './yes-no-cta.component.html',
  styleUrls: ['./yes-no-cta.component.scss'],
})
export class YesNoCtaComponent {
  @Input() content: YesNoCtaContent;
  @Output() pressedYes = new EventEmitter<boolean>();

  ButtonLevel = ButtonLevel;
  ButtonStyle = ButtonStyle;
}
export interface YesNoCtaContent {
  headingText: string;
  yesButtonText: string;
  noButtonText: string;
}
